<template>
    <section class="puchase_container">
        <h2>购券管理</h2>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">购券</el-menu-item>
            <el-menu-item index="2">购券历史</el-menu-item>
        </el-menu>
        <!-- {{form.resource}} -->
        <router-view/>
    </section>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: '1',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        addressList: []
      }
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key === '1') {
        this.$router.push({
          path: '/purchasecoupon/purchase'
        }).catch(err => {})
        this.$store.dispatch('purchase/initState', 'orderInfo')
      } else if (key === '2') {
        this.$router.push({
          path: '/purchasecoupon/history'
        }).catch(err => {})
      }
    }
  },
  computed: {
  },
  watch: {
    $route (to, from) {
      if (to.name === 'purchase' || to.name === 'pay') {
        this.activeIndex = '1'
      } else if (to.name === 'purchaseCouponHistory') {
        this.activeIndex = '2'
      }
    }
  },
  created () {
    let componentName = this.$route.name
    if (componentName === 'purchasecoupon') {
      this.$router.push({
        path: '/purchasecoupon/purchase'
      }).catch(err => {})
    } else if (componentName === 'purchase') {
      this.activeIndex = '1'
    } else if (componentName === 'purchaseCouponHistory') {
      this.activeIndex = '2'
    }
  },
  components: {
    // SelectCitys, SelectAddress
  }
}
</script>

<style lang="stylus">
    @import "../../styles/nav_horizontal.styl"
    .puchase_container
      background-color: #fff
    .el-menu-demo
      padding-left: 20px
</style>
